module.exports = __webpack_public_path__ + "img/two.6437fb6a.png";